import { Link } from 'react-router-dom';
import { z } from 'zod';
import { useTranslation } from '@dukanti/shared';
import { Button } from '@/components/ui/button';

// eslint-disable-next-line react-refresh/only-export-components
export const signupPhoneSchema = z.object({});
// eslint-disable-next-line react-refresh/only-export-components
export const signupCodeSchema = z.object({});
export type SignupPhoneFormValues = z.infer<typeof signupPhoneSchema>;
export type SignupCodeFormValues = z.infer<typeof signupCodeSchema>;

export function SignupForm() {
  const { t } = useTranslation();

  return (
    <section className="space-y-4 text-start" data-testid="signup-access-only">
      <div className="border-border bg-card rounded-xl border p-5 shadow-sm">
        <h2 className="font-display text-foreground text-2xl">
          {t('admin.authBoundary.missingTitle')}
        </h2>
        <p className="text-muted-foreground mt-3 text-sm leading-6">
          {t('admin.authBoundary.missingBody')}
        </p>
      </div>
      <Button asChild variant="outline" className="w-full">
        <Link to="/auth/signin" data-testid="signup-have-account-link">
          {t('auth.signup.signInLink')}
        </Link>
      </Button>
    </section>
  );
}
